const sessionKeys = {
  Token: 'token',
  RefreshToken: 'refreshToken',
};

export class SessionStorageService {
  static setToken(token: string): void {
    sessionStorage.setItem(sessionKeys.Token, token);
  }

  static setRefreshToken(refreshToken: string): void {
    sessionStorage.setItem(sessionKeys.RefreshToken, refreshToken);
  }

  static getToken(): string | null {
    return sessionStorage.getItem(sessionKeys.Token);
  }

  static getRefreshToken(): string | null {
    return sessionStorage.getItem(sessionKeys.RefreshToken);
  }

  static clearToken(): void {
    sessionStorage.removeItem(sessionKeys.Token);
    sessionStorage.removeItem(sessionKeys.RefreshToken);
  }
}
